module.exports = __webpack_public_path__ + "static/media/about_us_partnership.de82cb4f.svg";